namespace TabAurous.Retail {
    export interface POSSalesReceiptDetailsRow {
        ReceiptDetailsId?: number;
        ReceiptId?: number;
        DenominationId?: number;
        Code?: number;
        Count?: number;
        Amount?: number;
    }

    export namespace POSSalesReceiptDetailsRow {
        export const idProperty = 'ReceiptDetailsId';
        export const localTextPrefix = 'Retail.POSSalesReceiptDetails';
        export const deletePermission = 'Retail:POSSales:Delete';
        export const insertPermission = 'Retail:POSSales:Add';
        export const readPermission = '*';
        export const updatePermission = 'Retail:POSSales:Edit';

        export declare const enum Fields {
            ReceiptDetailsId = "ReceiptDetailsId",
            ReceiptId = "ReceiptId",
            DenominationId = "DenominationId",
            Code = "Code",
            Count = "Count",
            Amount = "Amount"
        }
    }
}
